import { PartnerLocation } from "../data/location";

type CallableLocation = Pick<
  PartnerLocation,
  "contactPhone" | "phoneNumberMask"
>;

interface CallUsLink {
  href: string;
  text: string;
}

// The mask only relabels the location's number, so a mask with no phone
// number behind it gets no link either: there is nothing to dial.
export function contactFormCallUsLink(
  location: CallableLocation | null
): CallUsLink | undefined {
  const phone = location?.contactPhone?.trim();
  if (!location || !phone) return undefined;

  return {
    href: `tel:${phone}`,
    text: location.phoneNumberMask?.trim() || `*${phone.slice(-4)}`,
  };
}
